<script type="text/javascript">
export default {};
</script>

<template>
  <div class="biggest-gains-loader">
    <div class="biggest-gains-loader__header">
      <div class="biggest-gains-loader__header-text"></div>
    </div>
    <div class="biggest-gains-loader__content">
      <div class="biggest-gains-loader-text-1"></div>
      <div class="biggest-gains-loader-text-2"></div>
      <div class="biggest-gains-loader-text-3"></div>
    </div>
  </div>
</template>

<style lang="scss">
@import '~styles/settings';

.biggest-gains-loader {
  background: $white;
  height: 128px;
  margin-bottom: 8px;

  body[data-theme='dark'] & {
    background: var(--surface-panel);
  }

  &__content {
    padding: 15px;
  }

  &-text-1 {
    @include text-line(100%, 9px);

    margin: 7px 0;
  }

  &-text-2 {
    @include text-line(100%, 9px);
  }

  &-text-3 {
    @include text-line(40%, 15px);

    margin: 7px 0;
  }

  &__header {
    background: $blue1;
    padding: 9px;
    width: 100%;
    height: 34px;

    body[data-theme='dark'] & {
      background: var(--surface-muted);
    }

    &-text {
      @include text-line(123px, 15px);
    }
  }
}
</style>
